<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 90vw">
      <div class="modal-header">
        <h5 class="modal-title">Add Patient Services</h5>
        <button type="button" @click="closeModal">X</button>
      </div>

      <div class="modal-body" style="min-height: 50vh">
        <div class="container">
          <div class="card mt-2 parent-div">
            <div class="table-container">
              <table class="table align-items-center mb-0 service-table">
                <thead>
                  <tr>
                    <th style="width: 35%">Service Name</th>
                    <th style="width: 15%">Tooth</th>
                    <th style="width: 30%">Other Body Part</th>
                    <th style="width: 10%">Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(service, index) in services" :key="service.id">
                    <!-- Service name -->
                    <td class="position-relative">
                      <input
                        type="text"
                        v-model="service.name"
                        @input="fetchServiceSuggestions(service)"
                        placeholder="Type service name"
                        class="form-control form-control-sm"
                      />

                      <ul
                        v-if="service.suggestions.length"
                        class="suggestions-list"
                      >
                        <li
                          v-for="suggestion in service.suggestions"
                          :key="suggestion.id"
                          @click="selectSuggestion(service, suggestion)"
                        >
                          {{ suggestion.name }}
                        </li>
                      </ul>
                    </td>

                    <!-- Tooth number -->
                    <td>
                      <select
                        v-model="service.tooth_number"
                        class="form-select form-select-sm"
                      >
                        <option value="">N/A</option>
                        <option
                          v-for="tooth in teeth"
                          :key="tooth.id"
                          :value="tooth.id"
                        >
                          {{ tooth.fdi_iso_number + " - " + tooth.tooth_name }}
                        </option>
                      </select>
                    </td>

                    <!-- Other body part -->
                    <td>
                      <input
                        type="text"
                        v-model="service.other_body_part"
                        placeholder="e.g. Left knee"
                        class="form-control form-control-sm"
                      />
                    </td>

                    <!-- Action -->
                    <td>
                      <button
                        class="mycustom-danger-button btn-sm"
                        @click="removeService(index)"
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <button class="mycustom-success-button mt-2" @click="addService">
                Add Another Service
              </button>
            </div>
          </div>
        </div>

        <div class="mt-4 text-end">
          <button class="mycustom-primary-button" @click="submitServices">
            Submit Services
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { generalApiRequest } from "../../api/apiIndex";
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "AddDentalProceduresModal",
  props: {
    visitId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      toothNumbers: Array.from({ length: 32 }, (_, i) => i + 1),
      teeth: [],
      services: [
        {
          id: Date.now(),
          name: "",
          suggestions: [],
          selected_service_id: null,
          tooth_number: "",
          other_body_part: "",
        },
      ],
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-add-service-modal");
    },

    async get_all_teeth() {
      const url = `dental/get_all_teeth`;
      const res = await generalApiRequest(url, "GET", {}, 1);
      console.log(res);
      this.teeth = res.data;
    },

    addService() {
      this.services.push({
        id: Date.now() + Math.random(),
        name: "",
        suggestions: [],
        selected_service_id: null,
        tooth_number: "",
        other_body_part: "",
      });
    },

    removeService(index) {
      this.services.splice(index, 1);
    },

    fetchServiceSuggestions(service) {
      if (!service.name) {
        service.suggestions = [];
        return;
      }

      const url = `search-medical-services?search=${service.name}`;
      generalApiRequest(url, "GET", {}, 1)
        .then((response) => {
          service.suggestions = response.data;
        })
        .catch((error) => {
          console.error("Error fetching suggestions:", error);
        });
    },

    selectSuggestion(service, suggestion) {
      service.name = suggestion.name;
      service.selected_service_id = suggestion.id;
      service.suggestions = [];
    },

    async submitServices() {
      const payload = this.services.map((service) => ({
        medical_service_id: service.selected_service_id,
        visit_id: this.visitId,
        quantity: 1,
        tooth_number: service.tooth_number || null,
        other_body_part: service.other_body_part || null,
      }));

      try {
        const url = "services/create";
        await generalApiRequest(url, "POST", payload, 1);
        this.closeModal();
        location.reload();
      } catch (error) {
        console.error("Error submitting services:", error);
      }
    },
  },
  mounted() {
    this.get_all_teeth();
  },
};
</script>

<style scoped>
.table-container {
  width: 100%;
}

.service-table th,
.service-table td {
  vertical-align: middle;
}

.form-control-sm,
.form-select-sm {
  padding: 0.35rem 0.5rem;
  font-size: 0.85rem;
}

.suggestions-list {
  position: absolute;
  z-index: 70;
  width: 100%;
  background: #fff;
  border: 1px solid #ccc;
  list-style: none;
  padding: 0;
  margin: 2px 0 0 0;
  max-height: 160px;
  overflow-y: auto;
}

.suggestions-list li {
  padding: 6px 10px;
  cursor: pointer;
}

.suggestions-list li:hover {
  background: #f0f0f0;
}
</style>
